/**
 * Répartition des liens de navigation du registry entre « haut » et « bas ».
 *
 * @remarks
 * Source unique du tri, partagée par la `Sidebar` (desktop/tablette) et par le
 * shell mobile : les liens `top` vont dans la barre du bas, les liens `bottom`
 * dans le menu compte mobile. Chaque feature décide
 * donc de sa place via `manifest.navigation[].position`, sans liste tenue à
 * part ici.
 */

import type { ResolvedNavigationLink } from '@/app/registry';

export interface SplitNavigationLinks {
  topLinks: ResolvedNavigationLink[];
  bottomLinks: ResolvedNavigationLink[];
}

/** Tri : `top` puis `bottom`, puis `order` ascendant (0 par défaut). */
export function splitNavigationLinks(
  links: readonly ResolvedNavigationLink[],
): SplitNavigationLinks {
  const sorted = [...links].sort((a, b) => {
    const aPos = a.position === 'bottom' ? 1 : 0;
    const bPos = b.position === 'bottom' ? 1 : 0;
    if (aPos !== bPos) return aPos - bPos;
    return (a.order ?? 0) - (b.order ?? 0);
  });
  return {
    topLinks: sorted.filter((l) => l.position !== 'bottom'),
    bottomLinks: sorted.filter((l) => l.position === 'bottom'),
  };
}

/**
 * Liens du shell mobile. `Paramètres` est exclu : il vit déjà dans le menu
 * compte (convention « compte »).
 */
export function getMobileNavigationLinks(
  links: readonly ResolvedNavigationLink[],
): SplitNavigationLinks {
  return splitNavigationLinks(links.filter((l) => l.id !== 'settings'));
}
